var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-header'),_c('main',{staticClass:"client-main"},[_c('client-nav'),(!_vm.isSuccess)?_c('submission-process'):_vm._e(),(!_vm.isSuccess)?_c('submission-explain'):_vm._e(),_vm._t("default")],2),_c('footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }